<template>
    <b-form-group :label="$t(placeholder)">
        <v-select
            label="title"
            :title="$t('Component(IncludedProductGroups):hover-instruction')"
            multiple
            :value="products"
            :placeholder="$t('Page(NewProduct):Component(Placeholder):product-groups-select-label')"
            :options="groups"
            @input="onChange"
        />
    </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import {ProductApi} from "@core/api";
import vSelect from 'vue-select'

export default {
    name: "IncludedProductGroups",
    components: {
        vSelect,
        BFormGroup
    },
    props: {
        selected: {
            type: Array,
            default() {
                return []
            }
        },
        placeholder: {
            type: String,
            default: 'Included into product groups'
        }
    },
    data() {
        return {
            groups: [],
            products: []
        };
    },
    methods: {
        onChange(v) {
            this.$emit('change', v);
        }
    },
    created() {
        ProductApi.getGroups().then(r => {
            this.groups = r.data;
            this.$emit('loaded', r.data);
        });
    },
    watch: {
        selected(value) {
            this.products = value;
        }
    }
}
</script>
